import {SiteDetail} from "./site-detail";
import {OfferChainDetail} from "./offer-chain-detail";
import { IDomainScript } from "./domain-script";
/**
 * Created by lsubramaniam on 11/2/17.
 */


export default class SiteDetailModel implements SiteDetail {
  orderPageId: string = '';
  trackerUrl: string = '';
  offerChainDetails: OfferChainDetail[] = [];
  offerChainId: string = '';
  archivedCampaignRedirectUrl: string = '';
  isCampaignArchived: boolean = false;
  success: boolean = false;
  brandId: string = '';
  storeFavionUrl: string = '';
  storePageTitle: string = '';
  googleTagManagerId: string = '';
  listTrackId: string = '';
  mixPanelId: string = '';
  monetateId: string = '';
  currentEnv: string = '';
  brandExpiryUrl: string = '';
  billingDescriptor: string = '';
  campaignType: string;
  campaignCss?: string | '';
  campaignJs?: string | '';
  redirectPromotionalEffortUrl : string = '';
  freeEletterPubs: string = '';
  externalJavaScriptFiles?: string | '';
  cookieConsentDomainScriptId?: string | null;
  domainScripts: Array<IDomainScript> | null;
  constructor() {}
}
